import { UserbotBatches } from "../../interfaces"

const pluralClients = (n: number): string => {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return `${n} клиент`
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${n} клиента`
  }
  return `${n} клиентов`
}

/** Человекочитаемая цель из targetSnapshot джобы (спека §5.1). */
export const describeBatchTarget = (
  target: UserbotBatches.AccountBatchJob["targetSnapshot"] | null | undefined,
): string => {
  if (!target) return "—"
  if (target.all === true) return "Все"
  if (target.role) return `Роль: ${target.role}`
  if (target.clientId) return `Клиент: ${target.clientId}`
  return Array.isArray(target.clientIds)
    ? pluralClients(target.clientIds.length)
    : "—"
}
